import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import {
	createZahlungsvorgangEpayblSaga,
	fetchZahlungsstatusEpayblSaga
} from "./sagas/createZahlungsvorgangEpayblSaga";

const zahlungsvorgangEpayblModule = (): Module => ({
	id: "zahlungsvorgangEpaybl",
	sagas: () => [createZahlungsvorgangEpayblSaga, fetchZahlungsstatusEpayblSaga]
});

export default zahlungsvorgangEpayblModule;
